import React from 'react';

import { Icon, Text } from 'styled-system';

import styles from './StatusLabel.module.scss';

type StatusLabelProps = {
    text: string;
    enabled: boolean;
};

export const StatusLabel = ({ text, enabled }: StatusLabelProps) => (
    <div className={styles.method}>
        {enabled ? (
            <Icon aria-label="enabled" color="success" name="s-icon-check" size="medium" />
        ) : (
            <Icon aria-label="disabled" color="danger" name="s-icon-xmark" size="medium" />
        )}
        <Text>{text}</Text>
    </div>
);
